import api from '../token';

export const DeleteArmazem = async (dados) => {
  try {
    const response = await api.post('/deleteArmazem', dados);
    return response.data;
  } catch (error) {
   
    return [];
  }
};




